import helper from '@/assets/function'

const state = {
	opt:		'001',
	opt_outro:	false,
	opt_pix:	false,
	clicklocal: false,
	ag_beneficiario: '',
	ag_benef_lista: {
		"001": "5745-2/119078-4",
		"033": "2090/8423830",
		"104": "1588/618518-5",
		"237": "2276/22420-0",
		"341": "8359/65132-3"
	},

	boleto:	{},
	pix:	{},

	boletobanco:{},

	try_register:{
		"001": false,
		"033": false,
		"104": false,
		"237": false,
		"341": false,
		"PIX": false
	},

	show_loading: false,

	boletoA: false,
	boletoB: false,
	
	forceMobile:		 false,
	iframePost:			 false,
	hideHeaderAndFooter: false,
	urlBrand:			 false,
	isMobile:			 false,
	showBoletoB:		 false,
	opcao_clicada:		 false,
	boletonotfound:		 false,
	boletodeadlock:		 false,
	boletovencido:		 false,
	boletopago:			 false,

	config:				[],
	boleto_permitido:	[],
	boleto_outro:	'001',
	boleto_padrao:	'001',

	listaBanco: []
}

// getters
const getters = {

	descricaoBanco: state => banco => {
		
		let ret = "";

		switch(banco){
			case '001':
				ret = "Banco do Brasil";
			break;
			case '104':
				ret = "Caixa ou lotéricas";
			break;
			case '341':
				ret = "Itaú";
			break;
			case '237':
				ret = "Bradesco";
			break;
			case '033':
				ret = "Santander";
			break;
		}

		return ret;
	},

	getQueryString: el => {
		//#/?
		let qs = window.location.hash;
		if(qs == ""){
			qs = window.location.search;
		}
		qs = qs.replace(/[\/?#?\?]/g, "");
		if(qs.indexOf("&") != -1){
			qs = qs.substr(0, qs.indexOf("&"));
			window.location.hash = window.location.hash.replace("&mobile=1", "");
			window.location.hash = window.location.hash.replace("&desktop=1", "");
			window.location.hash = window.location.hash.replace("&iframe=1", "");
		}

		return qs;
	},
}

// actions
const actions = {

	getBoleto({ commit, dispatch, state, getters }){

		commit('setShowLoading', true);

		let qs = getters.getQueryString;

		let data = new FormData();
		data.append("method", 	"opcao1");
		data.append("boleto_codigo",   qs);
		data.append("codigo_short",    qs);

		helper.axios().post('', data)
			.then(
				(response) => {

					var content;
					if(typeof response.data == "string"){
						content = JSON.parse(atob(response.data.replace("##data_##", "")));
					}else{
						content = response.data;
					}

					commit('setBoleto', content);
					commit('setAgBeneficiario');

					// Remove a opção EST das configurações
					// Embora esteja vindo como uma configuração, EST não é efetivamente um banco ou opção de clique
					let cfg = [];
					let est = [];
					content.config.forEach(el => {
						if(el.banco != "EST"){
							cfg.push(el);
						}else{
							est = el;
						}
					});

					commit('setConfig', cfg);

					if(state.urlBrand != false){
						commit('setOpt', state.urlBrand);
					}else{
						commit('setOpt', state.boleto_padrao);
					}

					// Caso a flag "bloqueado" venha setada como true, marca como se o boleto não existisse
					if(content.bloqueado == 1){
						commit('setBoletoNotFound', true);
					}

					// se estiver configurado para enviar estatística, envia.
					// caso contrário, não chama o método
					if(est.ativo == 1){
						dispatch('infoClient');
					}

					if(content.pago == 1){
						commit('setBoletoPago', true);
					}else if(content.vencido == 1){
						commit('setBoletoVencido', true);
					}

					window.setTimeout(function(){

						if(state.urlBrand != false){
							dispatch('tryRegistro', state.urlBrand);
						}else{

							/*
								--- condição para registro ---
								1) Se state.boleto.flash != '1', ou seja, é express, ele tenta registrar, independente do modelo AB.
								2) Ou se é flash, se espera que o registro aconteça no momento que usuário seleciona a opção de banco.
							*/

							if(state.boleto.flash != 1){
								dispatch('tryRegistro', state.boleto_padrao);
							}
						}
					}, 10);

					if(state.boleto.flash == 1){
						if(state.boleto_permitido.length == 1 && state.boleto_permitido[0] == 'PIX'){
							document.title = "PagBrasil Pix";
						}else{
							document.title = "Boleto Flash";
						}
					}

					commit('setShowLoading', false);
				}
			)
			.catch(err => {

				let aux = true;
				if(typeof err.response != "undefined"){
					if(typeof err.response.data != "undefined"){
						if(typeof err.response.data.Erro != "undefined"){
							if(err.response.data.Erro.toLowerCase().indexOf("deadlock") != -1){
								aux = false;
								commit('setBoletoDeadLock', true);
							}
						}
					}
				}

				if(aux){
					commit('setBoletoNotFound', true);
				}

				commit('setShowLoading', false);
			});
	},


	tryRegistro({ commit, dispatch, state, getters }, numbanco){

		let check = false;
		if(numbanco == ''){

			// Neste caso o boleto pode ser no santander, se o valor for maior que 200 reais
			let aux = 0;
			try{
				aux = parseFloat(state.boleto["valor"]);
			}catch(err){
				console.log(err);
			}

			if(aux >= 200){
				//numbanco = '033'; //Santander
				numbanco = state.boleto_outro; //opção "Outro" configurado no database
			}else{
				numbanco = state.boleto_outro; //opção "Outro" configurado no database
			}

			check = true;
		}

		if(numbanco == "PIX"){
			dispatch('getPIX');
			return;
		}

		// Antes de fazer a chamada, identifica se já tem os dados do banco
		if(typeof state.boleto != "undefined"){
			if(typeof state.boleto[numbanco] != "undefined"){
				if(typeof state.boleto[numbanco]["barcode"] != "undefined"){

					if(check){
						commit('setOptOutro', true);
					}else{
						commit('setOptOutro', false);
					}

					commit('setOpt', numbanco);
					commit('setBoletoBanco', [numbanco, state.boleto[numbanco]]);
					commit('setAgBeneficiario');

					commit('setTryRegister', numbanco);

					return;
				}
			}
		}

		let atual = state.opt;

		commit('setOpt', numbanco);

		commit('setShowLoading', true);

		let qs = getters.getQueryString;

		let data = new FormData();
		data.append("method",			"opcao2");
		data.append("banco",			numbanco);
		data.append("boleto_codigo",	qs);
		data.append("codigo_short",		qs);
			
		helper.axios().post('', data).then((response) => {
			commit('setShowLoading', false);

			var content;
			if(typeof response.data == "string"){
				content = JSON.parse(atob(response.data.replace("##data_##", "")));
			}else{
				content = response.data;
			}

			commit('setBoletoBanco', [numbanco, content]);
			commit('setAgBeneficiario');

			commit('setTryRegister', numbanco);

			if(check){
				commit('setOptOutro', true);
			}else{
				commit('setOptOutro', false);
			}
			
			dispatch('registraBoleto', numbanco);
			
		}).catch(err => {
			commit('setShowLoading', false);
			commit('setOpt', atual);
			//helper.callback_error(err.response.data);
		});
	},


	registraBoleto({ commit, state, getters }, numbanco){

		// aqui o sistema avalia se deve ou não tentar registrar
		if(typeof state.boleto.banco[numbanco].status != "undefined"){
			if(state.boleto.banco[numbanco].status == 1){
				return;
			}
		}

		let qs = getters.getQueryString;

		let data = new FormData();
		data.append("method",			"opcao3");
		data.append("banco",			numbanco);
		data.append("boleto_codigo",	qs);
		data.append("codigo_short",		qs);

		helper.axios().post('', data)
			.then(
				(response) => {
					// se não conseguiu registrar, não tem problema, o sistema de repescagem vai atuar
				}
			)
			.catch(err => {
					// se não conseguiu registrar, não tem problema, o sistema de repescagem vai atuar
				}
			);
	},


	infoClient({ commit, dispatch, state, getters }){

		let qs = getters.getQueryString;

		let data = new FormData();
		data.append("method",			"opcao4");
		data.append("boleto_codigo",	qs);
		data.append("codigo_short",		qs);

		data.append("merchant_number",	state.boleto.merchant_number);

		data.append("res_width",			screen.width);
		data.append("res_height",			screen.height);
		data.append("user_agent",			navigator.userAgent);
		data.append("user_agent_language",	navigator.language);
		data.append("browser_codename",		navigator.appCodeName);
		data.append("browser_name",			navigator.appName);
		data.append("browser_version",		navigator.appVersion);

		//alterado para setar os parametros com base na info vinda do getBoleto (API)
		data.append("modelo_A", (state.boleto.modeloAB == "A" ? 1 : 0));
		data.append("modelo_B", (state.boleto.modeloAB == "B" ? 1 : 0));

		helper.axios().post('', data)
			.then(
				(response) => { return true; }
			)
			.catch(err => { return true; }
			);
	},


	getPIX({commit, dispatch, state, getters}){

		commit('setShowLoading', true);

		let qs = getters.getQueryString;

		let data = new FormData();
		data.append("method",			"getPIX");
		data.append("boleto_codigo",	qs);
		data.append("codigo_short",		qs);

		helper.axios().post('', data).then((response) => {

			var content;
			if(typeof response.data == "string"){
				content = JSON.parse(atob(response.data.replace("##data_##", "")));
			}else{
				content = response.data;
			}

			commit('setPix',			content);
			commit('setOptPix',			true);
			commit('setTryRegister',	"PIX");
			commit('setOpt',			"PIX");

			commit('setShowLoading', false);

		}).catch(err => {
			commit('setShowLoading', false);

			alert("Erro desconhecido. Por favor, repita o processo de compra ou tente novamente mais tarde.");

			commit("setOpcaoClicada", false);
			commit("setClicklocal", false);
			//commit('setOpt', atual);
			//helper.callback_error(err.response.data);
		});
	}
}

// mutations
const mutations = {
	setBoleto(state, newVal){
		state.boleto = newVal;
		
		//verfica o tipo/modelo de boleto a ser renderizado com base na info/variavel de retorno do ajax
		/*
		if(newVal.modeloAB == "B"){
			state.boletoB = true;
			state.showBoletoB = true;
		}else{
			state.boletoA = true;
			state.showBoletoB = false;
		}
		//*/
		
		
		//seta forçadamente a renderizacao do MODELO A
		/*
		state.boletoA = true;
		state.showBoletoB = false;
		//*/
		
		//seta forçadamente a renderizacao do MODELO B
		///*
		state.boletoB = true;
		state.showBoletoB = true;
		//*/
	   
	},

	setBoletoBanco(state, content){
		let banco = content[0];

		state.boleto[banco] = content[1];
		state.boletobanco   = content[1];
	},

	setOpt(state, opt){
		state.opt = opt;
	},

	setOptOutro(state, opt){
		state.opt_outro = opt;
	},

	setOptPix(state, opt){
		state.opt_pix = opt;
	},

	setClicklocal(state, opt){
		state.clicklocal = opt;
	},

	setAgBeneficiario(state){
		state.ag_beneficiario = state.ag_benef_lista[state.opt];
	},

	setTryRegister(state, numbanco){
		state.try_register[numbanco] = true;
	},

	setShowLoading(state, val){
		state.show_loading = val;
	},

	setIsMobile(state, content){

		if(typeof content[1] != "undefined"){
			state.isMobile = content[1];
			return;
		}

		// Pode ocorrer uma informação na URL, forçando o mobile
		//#/?
		let qs = window.location.hash;
		if(qs == ""){
			qs = window.location.search;
		}
		qs = qs.replace(/[\/?#?\?]/g, "");

		let forceMobile = false;
		if(qs.indexOf("&mobile=1") != -1){
			qs = qs.replace("&mobile=1", "");
			forceMobile = true;
			window.location.hash = window.location.hash.replace("&mobile=1", "");
			history.pushState(null, null, "?" + qs);
		}

		let forceDesktop = false;
		if(qs.indexOf("&desktop=1") != -1){
			qs = qs.replace("&desktop=1", "");
			forceDesktop = true;
			window.location.hash = window.location.hash.replace("&desktop=1", "");
			history.pushState(null, null, "?" + qs);
		}

		let iframePost = false;
		if(qs.indexOf("&iframe=1") != -1){
			qs = qs.replace("&iframe=1", "");
			iframePost = true;
			window.location.hash = window.location.hash.replace("&iframe=1", "");
			history.pushState(null, null, "?" + qs);
		}

		let hideHeaderAndFooter = false;
		if(qs.indexOf("&clean=1") != -1){
			qs = qs.replace("&clean=1", "");
			hideHeaderAndFooter = true;
			window.location.hash = window.location.hash.replace("&clean=1", "");
			history.pushState(null, null, "?" + qs);
		}
		
		let urlBrand = false;
		if(qs.indexOf("&brand=") != -1){
			let pattern = "brand=";
			let qstring = qs.split('&');
			let xAux;
			
			for(xAux in qstring){
				if(qstring[xAux].indexOf(pattern) != -1){
					let tempBrand = qstring[xAux].split("=")
					urlBrand = tempBrand[1];
				}
			}
			
			qs = qs.replace('&'+ pattern + urlBrand, "");
			window.location.hash = window.location.hash.replace('&'+ pattern + urlBrand, "");
			history.pushState(null, null, "?" + qs);
		}
		
		var check = false;
		(function(a){if(/(bb\d+|meego).+mobile|android|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od|ad)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);

		if(forceMobile){
			state.isMobile = true;
			state.forceMobile = true;
		}else if(forceDesktop){
			state.isMobile = false;
		}else{
			state.isMobile = check;
		}

		if(iframePost){
			state.iframePost = true;
		}

		if(hideHeaderAndFooter){
			state.hideHeaderAndFooter = true;
		}
		
		if(urlBrand != false){
			state.urlBrand = urlBrand;
		}
	},

	setShowBoletoB(state, content){
		state.showBoletoB = content;
	},

	setOpcaoClicada(state, content){
		state.opcao_clicada = content;
	},

	setBoletoNotFound(state, content){
		state.boletonotfound = content;
	},

	setBoletoDeadLock(state, content){
		state.boletodeadlock = content;
	},

	setBoletoVencido(state, content){
		state.boletovencido = content;
	},

	setBoletoPago(state, content){
		state.boletopago = content;
	},

	setConfig(state, content){
		state.config = content;

		let bancos = [];

		// quantidade de opções ativas
		let qtdeAtivo = 0;
		content.forEach(el => {
			if(el.ativo == "1"){
				qtdeAtivo++;
			}
		});

		content.forEach(el => {
			if(el.ativo == "1"){
				if(el.banco == "PIX"){
					// se estiver vencido, não deve aparecer a opção
					// Entretanto, se apenas existir a opção de PIX, mesmo assim devemos exibir o pix
					if(parseInt(state.boleto.vencido) != 1 || qtdeAtivo == 1){
						state.boleto_permitido.push(el.banco);
					}
				}else{
					state.boleto_permitido.push(el.banco);
				}
			}

			if(el.opcao_outro == "1"){
				state.boleto_outro = el.banco;
			}

			if(el.primeira_opcao == "1"){
				state.boleto_padrao = el.banco;
			}

			if(el.banco != "PIX" && el.banco != "EST"){
				bancos.push({"ordem": el.ordem, "banco": el.banco});
			}else{
				// Se houver pix, e ele estiver ativo, habilita na visualização

				if(el.ativo == "1"){
					state.opt_pix = true;
				}
			}
		});

		bancos.sort(function(a, b) {
			return a.ordem - b.ordem;
		});

		state.listaBanco = [];

		bancos.forEach(el => {
			state.listaBanco.push(el.banco);
		});
	},

	sendPostIframe(state, content){
		if (state.iframePost) {
			parent.postMessage({fullLoading: true}, '*');
			// let event = new CustomEvent('fullLoading', {fullLoading: true});
			// parent.dispatchEvent('fullLoading');
		}
	},

	sendPostIframeOptionSelected(state, content){
		console.log("postmessagedoption_sended");
		if (state.iframePost) {
			parent.postMessage({optionSelected: true}, '*');
		}
	},

	setPix(state, content){
		state.pix = content;
	}
}

export default {
	namespaced: true,
	state,
	getters,
	actions,
	mutations
}